<template>
  <h1><van-icon name="success" /></h1>
  <div>您已完成提交</div>
  <div style="padding-bottom: 200px">感谢您的帮助与支持</div>
</template>
<style lang="scss" scoped>
  h1 {
    text-align: center;
    padding: 100px 0 20px;
    i {
      color: #058844;
      font-size: 68px;
    }
  }
  div {
    text-align: center;
    font-size: 18px;
    line-height: 1.8;
    font-weight: bold;
  }
</style>
